export default __webpack_public_path__ + "static/media/Barcode.7fe68901.svg";